export function IsValidJson(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (err) {
    return false;
  }
}

export function formatTime(days, hours) {
  //    return `  ${days || 0}D \u00A0 ${hours || 0}H `;
  var days = days > 0 && days < 10 ? "0" + days : days;
  if (hours > 0) {
    var hours = "0" + hours;
    if (days > 0) {
      return `  ${days || 0} D \u00A0 ${hours || 0} H `;
    } else {
      return `  ${hours || 0} H `;
    }
  } else {
    if (days > 0) return `  ${days || 0} D `;
  }
}

export const checkEffortHandler = (values, options, ...rest) => {
  if (options) {
    let objConvert = Object.keys(options);
    for (let i = 0; objConvert.length > i; i++) {
      let key = objConvert[i];
      let value = options[key];
      //        if (values && values > 0) {
      //          return `${values || 0} H`;
      //        }
      if (values && values > value.total_hours) {
        if (rest && rest.length > 0) {
          let [val] = rest;
          let result = ""; //value.name;
          const { effort_in_days, effort_in_hours } = val;
          return (result += formatTime(effort_in_days, effort_in_hours));
        }
      }
    }
  }
  if (values) {
    if (rest && rest.length > 0) {
      let [val] = rest;
      let result = ""; //value.name;
      const { effort_in_days, effort_in_hours } = val;
      return (result += formatTime(effort_in_days, effort_in_hours));
    }
  }
  return null;
};

export const deepCleanObject = (obj) => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return obj;

  return Object.fromEntries(
    Object.entries(obj)
      .map(([key, value]) => {
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const cleaned = deepCleanObject(value);

          // Keep 'filter' and 'filters' keys even if empty after cleaning
          if (key === 'filters' || key === 'filter') {
            return [key, cleaned];
          }

          // Drop the key if cleaned object is now empty
          return Object.keys(cleaned).length ? [key, cleaned] : null;

        } else if (
          value === null ||
          value === '' ||
          (Array.isArray(value) && value.length === 0)
        ) {
          return null;
        } else {
          return [key, value];
        }
      })
      .filter(Boolean)
  );
};
